import { create } from "zustand";

// Width of the Activity Sidebar rail (px). Shared so the Layout can reserve the
// matching right-margin for the main content when the rail pushes (SIMS-7579 UI).
export const ACTIVITY_SIDEBAR_WIDTH = 360;

// Height of the fixed AppBar (px). Single source of truth shared by the Layout
// (top offset / min-height of <Main>, AppBar height) and the Activity Sidebar
// rail, which sits below the AppBar like the left nav (SIMS-7579 UI).
export const APP_BAR_HEIGHT = 82;

interface ActivitySidebarUiState {
	// True only while the rail is open in persistent (push) mode on a wide
	// screen. The ActivitySidebar sets this; the Layout reads it to give the
	// main content a right margin so the rail pushes content instead of
	// overlapping it. On narrower screens the rail falls back to an overlay
	// drawer and this stays false (no push).
	pushing: boolean;
	setPushing: (pushing: boolean) => void;
}

export const useActivitySidebarUiStore = create<ActivitySidebarUiState>(
	(set) => ({
		pushing: false,
		setPushing: (pushing) => set({ pushing }),
	}),
);
